
export function getQueryIdFromRoute(path: string): string {
  if (path.startsWith('/task/') || path === '/task') {
    return 'search-task';
  }
  if (path.startsWith('/third/') || path === '/third') {
    return 'third-search-filter';
  }
  if (path.startsWith('/demand/') || path === '/demand') {
    return 'demand-search-filter';
  }
  if (path.startsWith('/delivery/') || path === '/delivery') {
    return 'delivery-schedule-filter';
  }
  if (path === '/order') {
    return 'order-search-filter';
  }
  return '';
}
